import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-six',
  templateUrl: './feature-six.component.html',
  styleUrls: ['./feature-six.component.css']
})
export class FeatureSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
